
import StoreLocation from '~/pages/_lang/activity/store/index.vue'
export default StoreLocation
